import React from 'react';
import TitleComponent from '../../common/titleComponent';
import { Divider, Paper } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const PermissionsList = ({ data: permissions }) => {
  return (
    <Paper className='paper'>
      <TitleComponent entity={'Permisos extra'} />
      <Divider />
      <div>
        <List dense={true}>
          {permissions.length > 0 ? (
            permissions.map((permission) => (
              <ListItem divider key={permission.id}>
                <ListItemText primary={permission.display_name} />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText primary={'No tienes permisos extra'} />
            </ListItem>
          )}
        </List>
      </div>
    </Paper>
  );
};

export default PermissionsList;
